export { FullPageAppTemplate } from './FullPageAppTemplate'
export { getStateContent } from './FullPageAppTemplate.utils'
